import { Model } from "vue-mc";
import { required, string } from "vue-mc/validation";

class Rendered extends Model {
  options() {
    return {
      editable: true,
      mutateOnChange: true,
    };
  }

  defaults() {
    return {
      rendered: null,
      protected: false,
    };
  }

  // Attribute mutations.
  mutations() {
    return {
      rendered: String,
      protected: Boolean,
    };
  }

  validation() {
    return {
      rendered: string.and(required),
    };
  }
}

export default Rendered;
